import { Button, Classes, H3, H6, Intent, Overlay } from "@blueprintjs/core";
import { handleBooleanChange } from "@blueprintjs/docs-theme";
import classNames from "classnames";
import moment from 'moment-timezone';
import * as React from "react";
import TextareaAutosize from 'react-autosize-textarea';
import NumberFormat from 'react-number-format';
import { ERROR_TOAST_ICON, NOTE_DATE_TIME_FORMAT } from "../../../utils/Constants";
import { patchTrip } from "../../services/tripApiService";
import {
    flexColumn, flexRow, labelContainer, overlayDivContainer, overlayFooterConfirmProvider, requiredColor,
    textareaContainer, textareaPadding, waitTimeMinutesTitle, waitTimeNotesArea, waitTimeNumberInput, waitTimeSaveButton,
    waitTimeSubcontainer, waitTimeTitleInput
} from '../../styles';
import { AppToaster } from "../../toastComponent";


const OVERLAY_EXAMPLE_CLASS = "docs-overlay-example-transition";
const OVERLAY_TALL_CLASS = "docs-overlay-example-tall";


class OverlayWaitTime extends React.PureComponent {

    constructor(props) {
        super(props)

        this.setState({
            trip: this.props.trip
        })
    }

    state = {
        autoFocus: true,
        canEscapeKeyClose: true,
        canOutsideClickClose: true,
        enforceFocus: true,
        isOpen: true,
        usePortal: true,
        isConfirmDisabled: true,
        waitTimeMinutes: 0,
        waitTimeNotes: ''
    };

    handleAutoFocusChange = handleBooleanChange(autoFocus => this.setState({ autoFocus }));
    handleOutsideClickChange = handleBooleanChange(val => this.setState({ canOutsideClickClose: val }));
    handleEnforceFocusChange = handleBooleanChange(enforceFocus => this.setState({ enforceFocus }));
    handleEscapeKeyChange = handleBooleanChange(canEscapeKeyClose => this.setState({ canEscapeKeyClose }));
    handleUsePortalChange = handleBooleanChange(usePortal => this.setState({ usePortal }));


    handleConfirm = async () => {
        if (this.state.waitTimeMinutes === '') {
            AppToaster.show({ message: "* Complete mandatory fields.", intent: "danger", icon: ERROR_TOAST_ICON, });
            return;
        }

        var note = this.formatNote();

        try {
            await patchTrip(this.props.trip.tripNumber, this.state.waitTimeMinutes, note);
            AppToaster.show({ message: "Wait time added.", intent: "success", icon: 'tick', });
            this.handleClose();
        }
        catch (error) {
            console.log(error);
            AppToaster.show({ message: "There was an error saving wait time. Please try again.", intent: "danger", icon: ERROR_TOAST_ICON, });
        }
    }

    componentDidMount() {
        this.setState({
            waitTimeMinutes: Number(this.props.trip?.waitMinutes),
        })
    }

    formatNote() {
        var user = localStorage.getItem('user');
        var localDateTime = moment().format(NOTE_DATE_TIME_FORMAT);
        var localToPickup = moment(localDateTime).utc().format(NOTE_DATE_TIME_FORMAT);
        var utcOffset = '+0:00';

        if (this.props.trip?.pickupTimeZone) {
            localToPickup = moment(localDateTime).tz(this.props.trip?.pickupTimeZone).format(NOTE_DATE_TIME_FORMAT);
            utcOffset = moment.tz(this.props.trip?.pickupTimeZone).format('Z');
        }

        return `${this.state.waitTimeNotes} USER ${user} SET ${this.state.waitTimeMinutes} MINUTES OF WAIT TIME TO THE TRIP @ ${localToPickup} UTC ${utcOffset}.`
    }

    handleMinutesChange = (event) => {
        let minutes = event.target.value
        minutes = minutes.trim();

        this.setState({
            waitTimeMinutes: Number(minutes),
        });
    }

    handleNotesChange = (event) => {
        const notes = event.target.value
        this.setState({
            waitTimeNotes: notes,
        });
    }

    render() {
        const classes = classNames(
            Classes.CARD,
            Classes.ELEVATION_4,
            OVERLAY_EXAMPLE_CLASS,
            localStorage.getItem("themeName"),
            { [OVERLAY_TALL_CLASS]: this.state.useTallContent },
        );

        return (
            <Overlay className={Classes.OVERLAY_SCROLL_CONTAINER} transitionName={Classes.OVERLAY} onClose={this.handleClose} {...this.state}>
                <div className={classes} style={overlayDivContainer}>
                    <div style={waitTimeSubcontainer}>
                        <H3>Add Wait Time</H3>
                        <br />
                        <div>
                            <label style={labelContainer}>
                                <div style={flexRow}>
                                    <div style={waitTimeTitleInput}>
                                        <H6><strong>Insert the total wait time:&nbsp;</strong></H6>
                                        <H6 style={waitTimeMinutesTitle}>(in minutes)</H6>
                                        <H3 style={requiredColor}>*</H3>
                                    </div>
                                    <NumberFormat
                                        name="waitTimeMinutes"
                                        placeholder="Total minutes"
                                        style={waitTimeNumberInput}
                                        format={'###'}
                                        value={this.state.waitTimeMinutes}
                                        onChange={this.handleMinutesChange}
                                    />
                                </div>
                            </label>
                        </div>
                        <div style={textareaPadding}>
                            <label style={textareaContainer}>
                                <div style={flexColumn}>
                                    <div style={waitTimeTitleInput}>
                                        <H6><strong>Include notes:&nbsp;</strong></H6>
                                        <H6 style={waitTimeMinutesTitle}>(if needed)</H6>
                                    </div>
                                    <TextareaAutosize
                                        disabled={this.state.waitTimeMinutes === null}
                                        name="waitTimeNotes"
                                        style={waitTimeNotesArea}
                                        rows={3}
                                        placeholder='&nbsp;Internal notes'
                                        value={this.state.waitTimeNotes}
                                        onChange={this.handleNotesChange}
                                    />
                                </div>

                            </label>
                        </div>
                        <br />
                        <div className={Classes.OVERLAY_FOOTER_ACTIONS} style={overlayFooterConfirmProvider}>
                            <Button intent={Intent.SUCCESS} style={waitTimeSaveButton} onClick={() => this.handleConfirm()} text="Save" />
                            <Button intent={Intent.NONE} onClick={this.handleClose} text="Cancel" />
                        </div>
                    </div>
                </div>
            </Overlay>
        );
    }

    handleOpen = () => this.setState({ isOpen: true });
    handleClose = () => {
        this.setState({ isOpen: false });

        this.props.onModalClosed(this.props.id);
    }
}


export default OverlayWaitTime;
